"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.stat.scheduled': '已计划',
    'socialMediaPlan.stat.drafts': '草稿',
    'socialMediaPlan.stat.published': '已发布',
    'socialMediaPlan.stat.total': '总计',
};
